import React from 'react';


export class DashboardRedirect extends React.Component {
  constructor(props) {
    super(props);
    props.history.push('/');
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardRedirect.js